import type { ProfileData } from "shared/schema";
import { Icon } from "shared/react";
import { getCounterStreak } from "shared/schema";
import { formatCompactNumber } from "shared/util/number";

export function ProfileStats({ points, love }: ProfileData) {
	const streak = getCounterStreak(points);
	return (
		<>
			<data className="button" value={points.total}>
				<Icon icon="star" mods="color-yellow" /> <span>{formatCompactNumber(points.total)}</span>
			</data>
			<data className="button" value={streak}>
				<Icon icon="fire" mods="color-orange" /> <span>{formatCompactNumber(streak)}</span>
			</data>
			<data className="button" value={love.total}>
				<Icon icon="heart" mods="color-pink" /> <span>{formatCompactNumber(love.total)}</span>
			</data>
		</>
	);
}
